<template>
    <div class="vrm-badge--beta">
        {{ $t('common.beta', { i18nFallback: 'BETA' }) }}
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularDirective('vrm-beta-badge')
@AngularLocaleBundle('common')
export default class VrmBetaBadge extends Vue {}
</script>
